import {
  Box,
  Button,
  Snackbar,
  Alert,
  Typography,
  CircularProgress,
  Grid,
  Paper,
  Chip,

  Divider
} from '@mui/material';
import { Header } from 'components/home';
import { ContainerForm } from 'components/shared/container_form';
import { TopNavBar } from 'components/top_nav_bar';
import { MenuProvider } from 'contexts/menu/menu_context';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
import { CuffaAPI } from 'api/cuffa/cuffa.api';

export const CadrastroProdutosVisualizar: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [dados, setDados] = useState<any>(null);
  const [dataProducts, setDataProducts] = useState<any>(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarError, setSnackbarError] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const { uuid } = useParams<{ uuid: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      if (!uuid) {
        setSnackbarMessage("UUID da coleta não encontrado na URL.");
        setSnackbarError(true);
        setOpenSnackbar(true);
        setLoading(false);
        return;
      }

      // Tenta restaurar do localStorage 'cuffa-storage' antes de chamar a API
      try {
        const storageKey = 'cuffa-storage';
        const raw = typeof window !== 'undefined' ? localStorage.getItem(storageKey) : null;
        if (raw) {
          try {
            const parsed = JSON.parse(raw);
            const saved = parsed?.state?.dadosParciais;
            if (saved) {
              // Se houver categoriaFundiaria salva, usa para preencher 'dados'
              if (saved.categoriaFundiaria) {
                const cat = saved.categoriaFundiaria;
                setDados({
                  land_category: cat.landCategory || '',
                  land_category_additional_info: cat.codigoAssentamento || cat.nomePncFTerraBrasilBancoDaTerra || cat.nomeComunidadeQuilombola || cat.nomeComunidadeTradicional || cat.nomeTerraIndigena || '',
                });
                setLoading(false);
                return;
              }
              // Caso o storage contenha um objeto 'dados' diretamente, usa-o
              if (saved.dados) {
                setDados(saved.dados);
                setLoading(false);
                return;
              }
            }
          } catch (e) {
            console.warn('Falha ao parsear cuffa-storage ao restaurar dados:', e);
          }
        }
      } catch (e) {
        console.warn('Erro ao acessar localStorage cuffa-storage:', e);
      }

      try {
        const response = await CuffaAPI.getDataByID(uuid);

        if (response && response.dados) {
          const apiData = response.dados;
          setDados(apiData);
        } else {
          console.error("Dados de produção não encontrados na resposta da API:", response);
          setDados(null);
        }
      } catch (error) {
        console.error("Erro ao buscar dados de produção:", error);
        setSnackbarMessage("Erro ao buscar dados de produção.");
        setSnackbarError(true);
        setOpenSnackbar(true);
        setDados(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [uuid]);


  useEffect(() => {
    const fetchDataProduct = async () => {
      if (!uuid) {
        setSnackbarMessage("UUID da coleta não encontrado na URL.");
        setSnackbarError(true);
        setOpenSnackbar(true);
        setLoading(false);
        return;
      }

      // Tenta restaurar lista de produtos do localStorage 'cuffa-storage'
      try {
        const storageKey = 'cuffa-storage';
        const raw = typeof window !== 'undefined' ? localStorage.getItem(storageKey) : null;
        if (raw) {
          try {
            const parsed = JSON.parse(raw);
            const saved = parsed?.state?.dadosParciais;
            if (saved) {
              // Possíveis chaves onde produtos podem ter sido salvos
              const candidates = ['produtos', 'produtosSelecionados', 'cadastroProdutos', 'cadastrarProdutos', 'cadastraProdutos', 'dataProducts', 'products'];
              for (const key of candidates) {
                const val = saved[key];
                if (Array.isArray(val) && val.length > 0) {
                  // heurística: verificar se os itens parecem produtos
                  const item = val[0];
                  if (item && (item.product_name || item.product_type || item.collection_product_uuid)) {
                    setDataProducts(val);
                    setLoading(false);
                    return;
                  }
                }
              }
              // Se storage tiver 'dataProducts' diretamente em root
              if (saved.dataProducts && Array.isArray(saved.dataProducts)) {
                setDataProducts(saved.dataProducts);
                setLoading(false);
                return;
              }
            }
          } catch (e) {
            console.warn('Falha ao parsear cuffa-storage ao restaurar produtos:', e);
          }
        }
      } catch (e) {
        console.warn('Erro ao acessar localStorage cuffa-storage:', e);
      }

      try {
        const response = await CuffaAPI.getDataByIDProdutos(uuid);

        if (response && response.dados) {
          const apiData = response.dados;
          console.log("DADOS RETORNADOS API produtos", apiData);
          setDataProducts(apiData);

        } else {
          console.error("Dados de produção não encontrados na resposta da API:", response);
          setDataProducts(null);
        }
      } catch (error) {
        console.error("Erro ao buscar dados de produção:", error);
        setSnackbarMessage("Erro ao buscar dados de produção.");
        setSnackbarError(true);
        setOpenSnackbar(true);
        setDados(null);
      } finally {
        setLoading(false);
      }
    };

    fetchDataProduct();
  }, [uuid]);

  console.log(dataProducts);
  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    );
  }

  if (!dados) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <Typography>Nenhum dado encontrado para visualização.</Typography>
      </Box>
    );
  }

  return (
    <MenuProvider>
      <TopNavBar />
      <Header title="Cadastro de Produtos" showBackButton />

      <Box display="flex" justifyContent="center" mt={4}>
        <ContainerForm title="Cadastro de Produtos" width='1152px'>

          {/* Categoria Fundiária - Agora em primeiro lugar */}
          <Box mb={4}>
            <Typography variant="h6" gutterBottom>
              Categoria Fundiária
            </Typography>
            <Paper elevation={0} sx={{ p: 3, mb: 4, border: '2px solid #000', borderRadius: '8px' }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" fontWeight="bold">Categoria:</Typography>
                  <Typography>{dados.land_category || 'Não informado'}</Typography>
                </Grid>
                {dados.land_category_additional_info && (
                  <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2" fontWeight="bold">Informações Adicionais:</Typography>
                    <Typography>{dados.land_category_additional_info}</Typography>
                  </Grid>
                )}
              </Grid>
            </Paper>
          </Box>

          {/* ETAPA 2: Tipo de Produção */}
          <Box mb={4}>
            <Typography variant="h6" gutterBottom>
              2. Tipo de Produção
            </Typography>
            <Paper elevation={0} sx={{ p: 3, mb: 2, border: '2px solid #000', borderRadius: '8px' }}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" fontWeight="bold">Tipo de Produção:</Typography>
                  <Typography>{dataProducts?.[0]?.production_type || 'Não informado'}</Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" fontWeight="bold">Tipo de Manejo:</Typography>
                  <Typography>{dataProducts?.[0]?.management_type || 'Não informado'}</Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography variant="subtitle2" fontWeight="bold">Produz Processados:</Typography>
                  <Typography>{dataProducts?.[0]?.is_processed ? 'Sim' : 'Não'}</Typography>
                </Grid>
              </Grid>
            </Paper>
          </Box>


          {/* ETAPA 3: Produtos Selecionados */}
          <Box mb={4}>
            <Typography variant="h6" gutterBottom>
              3. Produtos Selecionados
            </Typography>

            {dataProducts && dataProducts.length > 0 ? (
              dataProducts.map((product: any, index: number) => (
                <Paper
                  key={product.collection_product_uuid || index}
                  elevation={0}
                  sx={{ p: 3, mb: 3, border: '2px solid #000', borderRadius: '8px' }}
                >
                  {/* Produto principal */}
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" fontWeight="bold">Produto:</Typography>
                      <Typography>{product.product_name || 'Não informado'}</Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" fontWeight="bold">Tipo:</Typography>
                      <Typography>{product.product_type || 'Não informado'}</Typography>
                    </Grid>
                  </Grid>

                  <Divider sx={{ my: 2 }} />

                  {/* Detalhes do Produto */}
                  <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                    Detalhes do Produto
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" fontWeight="bold">Quantidade Produzida:</Typography>
                      <Typography>{product.produced_quantity} {product.measurement_unit}</Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" fontWeight="bold">Área (ha):</Typography>
                      <Typography>{product.area_hectares || '-'}</Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" fontWeight="bold">Volume Produzido:</Typography>
                      <Typography>{product.volume_produced || '-'}</Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" fontWeight="bold">Volume Comercializado:</Typography>
                      <Typography>{product.volume_commercialized || '-'}</Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" fontWeight="bold">Valor Comercializado:</Typography>
                      <Typography>{product.commercialized_value || '-'}</Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" fontWeight="bold">Volume Consumido/Doado:</Typography>
                      <Typography>{product.volume_consumed_donated || '-'}</Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" fontWeight="bold">Volume Perdido:</Typography>
                      <Typography>{product.volume_lost || '-'}</Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" fontWeight="bold">Certificação:</Typography>
                      <Typography>
                        {product.has_certification ? (product.certification_type || product.other_certification_name) : 'Sem certificação'}
                      </Typography>
                    </Grid>
                  </Grid>

                  <Divider sx={{ my: 2 }} />

                  {/* Disponibilidade por meses */}
                  <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                    Disponibilidade
                  </Typography>
                  {product.availability_months?.available_year_round ? (
                    <Typography>Disponível o ano todo</Typography>
                  ) : (
                    <Grid container spacing={1}>
                      {Object.entries(product.availability_months || {})
                        .filter(([month, available]) => available === true)
                        .map(([month]) => (
                          <Grid item key={month}>
                            <Chip label={month} color="primary" />
                          </Grid>
                        ))}
                    </Grid>
                  )}
                </Paper>
              ))
            ) : (
              <Typography>Nenhum produto cadastrado.</Typography>
            )}
          </Box>


          {/* Botões de Navegação */}
          <Box marginTop="2rem" display="flex" justifyContent="center" gap="1rem">
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => {
                if (uuid) {
                  navigate(ROUTES.VISITAS_INSTITUICOES_CUFFA_VISUALIZAR.replace(':uuid', uuid));
                }
              }}
            >
              Voltar
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                if (uuid) {
                  navigate(ROUTES.PRODUCAO_AGROECOLOGICA_VISUALIZAR.replace(':uuid', uuid));
                }
              }}
            >
              Avançar
            </Button>
          </Box>
        </ContainerForm>
      </Box>

      {/* Snackbar de Feedback */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          severity={snackbarError ? 'error' : 'success'}
          sx={{ width: '100%' }}
          onClose={handleCloseSnackbar}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </MenuProvider>
  );
};

export default CadrastroProdutosVisualizar;
